// extracted by mini-css-extract-plugin
export default {"nosotros":"Nosotros_nosotros__YUP4W","parrafos":"Nosotros_parrafos__uPsQb","image":"Nosotros_image__-dBPZ","cards":"Nosotros_cards__bZJoI"};